import styled from "styled-components";
import { Text } from "rebass";

export const Input = styled(Text)`
  color: ${({ theme: { colors } }) => colors["zodiac"]};
  background: #fff;

  &::placeholder {
    color: ${({ theme: { colors } }) => colors["wild-blue"]};
  }
`;

Input.defaultProps = {
  as: "input",
};
